import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=41006a5c&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41006a5c')) {
      api.createRecord('41006a5c', component.options)
    } else {
      api.reload('41006a5c', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=41006a5c&", function () {
      api.rerender('41006a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/Material/Form.vue"
export default component.exports